import React from 'react';
import { View, Text, StyleSheet, ScrollView, StyleProp, ViewStyle } from 'react-native';

export interface TermsOfServiceBodyProps {
  t: (key: string) => string;
  style?: StyleProp<ViewStyle>;
  contentContainerStyle?: StyleProp<ViewStyle>;
}

const TermsOfServiceBody: React.FC<TermsOfServiceBodyProps> = ({ t, style, contentContainerStyle }) => {
  return (
    <ScrollView 
      style={[styles.content, style]}
      contentContainerStyle={[styles.scrollContent, contentContainerStyle]}
      showsVerticalScrollIndicator={false}
    >
      <Text style={styles.sectionTitle}>{t('termsOfServiceScreen.acceptanceOfTerms')}</Text>
      <Text style={styles.termsText}>
        {t('termsOfServiceScreen.acceptanceContent')}
      </Text>

      <Text style={styles.sectionTitle}>{t('termsOfServiceScreen.serviceDescription')}</Text>
      <Text style={styles.termsText}>
        {t('termsOfServiceScreen.serviceDescriptionContent')}
      </Text>

      <Text style={styles.sectionTitle}>{t('termsOfServiceScreen.userResponsibilities')}</Text>
      <Text style={styles.termsText}>
        {t('termsOfServiceScreen.userResponsibilitiesContent')}
      </Text>

      <Text style={styles.sectionTitle}>{t('termsOfServiceScreen.serviceLimitations')}</Text>
      <Text style={styles.termsText}>
        {t('termsOfServiceScreen.serviceLimitationsContent')}
      </Text>

      <Text style={styles.sectionTitle}>{t('termsOfServiceScreen.disclaimer')}</Text>
      <Text style={styles.termsText}>
        {t('termsOfServiceScreen.disclaimerContent')}
      </Text>

      <Text style={styles.sectionTitle}>{t('termsOfServiceScreen.termsModification')}</Text>
      <Text style={styles.termsText}>
        {t('termsOfServiceScreen.termsModificationContent')}
      </Text>

      <Text style={styles.sectionTitle}>{t('termsOfServiceScreen.contactUs')}</Text>
      <Text style={styles.termsText}>
        {t('termsOfServiceScreen.contactUsContent')}
      </Text>

      <Text style={styles.updateInfo}>
        {t('termsOfServiceScreen.lastUpdated')}
      </Text>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  content: {
    flex: 1,
  },
  scrollContent: {
    padding: 16,
    paddingBottom: 32,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#333',
    marginTop: 24,
    marginBottom: 12,
  },
  termsText: {
    fontSize: 14,
    color: '#666',
    lineHeight: 22,
    marginBottom: 16,
  },
  updateInfo: {
    fontSize: 12,
    color: '#999',
    textAlign: 'center',
    marginTop: 32,
    fontStyle: 'italic',
  },
});

export default TermsOfServiceBody;
